<!-- MODAL HEADER-->
<div class="row modal-bar mb-5">

  <div class="col-sm-6 d-flex align-items-center justify-content-start">
    <h5 class="modal-title mb-0 me-3">{{ passedData.title }}</h5>

    @if (customerPassePartout.ExcludeFromLinking === true) {
      <div class="ms-2 text-danger">
        <span> {{ getExcludeFromLinkingBy() }}</span>
        <span class="ms-1">({{ getExcludeFromLinkingTimestamp() }})</span>
      </div>
    }
  </div>

  <div class="col-sm-6">

    <div class="modal-actions">

      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>

<t4-list-view #listVw [options]="listOptions" (onDataRequest)="OnDataRequest($event)">

  <ng-container *t4ListItem="let item;">

    <td>{{item.EventPlacementId }}</td>
    <td>{{item.EventStartDateTime | localDateTime | slice:0:10 }}</td>
    <td>{{item.EventStartDateTime | localTime}}</td>
    <td>{{item.EventName }}</td>
    <td>{{item.ParentShortName }}</td>
    <td>{{ item.RowNumber | replaceOnEmpty }} / {{ item.SeatNumber | replaceOnEmpty}}</td>
    <td>{{item.Barcode}}</td>
    @if (this.secondaryTicketingActive) {
      <td><span [ngClass]="getTicketSwapStatusClass(item.LatestTicketSwapStatus)">{{getTicketSwapStatus(item.LatestTicketSwapStatus) | translate}}</span></td>
    }
    <td>{{item.DeletionReason  | replaceOnEmpty }}</td>
    <td>{{item.DeletedByUserFullname  | replaceOnEmpty }} </td>

    <td class="grid-action">
      @if (ibaActive) {
        <button [disabled]="item.CanRevokeInBackoffice === false" (click)="revoke(item)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-step-backward" ></button>
      }
      @if (ibaActive) {
        <button (click)="openAssignmentHistory(item.EventPlacementId)" type="button" class="btn btn-grid btn-round mdi mdi-primary mdi-history"></button>
      }
      @if (item.Deleted == false) {
        <button [disabled]="!this.itemDeletable(item)" (click)="confirmDelete(item)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
      }
      @if (item.Deleted == true) {
        <span class="me-3" style="color: red;">{{'GENERIC.DELETED' | translate}}</span>
      }
    </td>

  </ng-container>
</t4-list-view>

<div class="modal-footer justify-content-end">
  <span class="me-3">{{ 'COMPONENTS.CUSTOMER-PASSEPARTOUTS.CONFIRM.INFO.EXCLUDE-FROM-LINKING' | translate }}</span>
  <button [disabled]="customerPassePartout.ExcludeFromLinking === true" (click)="toggleExcludeFromLinking()" type="button"
  class="btn btn-danger">{{ 'COMPONENTS.CUSTOMER-PASSEPARTOUTS.CONFIRM.BTN.EXCLUDE-FROM-LINKING' | translate}}</button>
</div>



